import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import type { Hero } from 'src/types/infra/supabase'
import One55SymbolWhite from 'src/app/assets/icons/ico-155-symbol.svg'

type Props = Readonly<{
  hero?: Hero
}>

export function AnonymousPlayerView({ hero }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div className="race-loading-indicator-outer">
      <div className="race-loading-indicator">
        <div className="race-loading-indicator__inner">
          <One55SymbolWhite />
          <div className="text">
            <span className="primary">{t('We were not able to authenticate you.')}</span>
            <span className="secondary">{t('Please try again.')}</span>
          </div>
        </div>
      </div>
      {hero ? (
        <div className="loading-indicator__background">
          {hero.image ? (
            <video
              autoPlay
              controlsList="nodownload"
              disablePictureInPicture
              loop
              muted
              playsInline
              poster={`/assets/tracks-backgrounds/${hero.image}.webp`}
              src={`/assets/tracks-backgrounds/${hero.image}-video.mp4`}
            />
          ) : null}
        </div>
      ) : (
        <div className="loading-indicator__background">
          <img alt="" src="/assets/marbles-racetrack-loading-screen.webp" />
        </div>
      )}
    </div>
  )
}
